import {
    SUPPORTER_EMERGENCY_CONTACT_REQUEST,
    SUPPORTER_EMERGENCY_CONTACT_RECEIVE,
    SUPPORTER_EMERGENCY_CONTACT_CHANGE_VALUE,
    SUPPORTER_EMERGENCY_CONTACT_SEND_SAVE,
    SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE,
    SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE_ERROR,
    SUPPORTER_EMERGENCY_CONTACT_EDIT
} from "../config/actions";

let defaultState = {
    id: null,
    lastname: '',
    firstname: '',
    phone: '',
    type: '',
    availableTypes: null,
    edit: false,
    loading: false,
    errors: false
};

const supporterEmergencyContactReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(SUPPORTER_EMERGENCY_CONTACT_REQUEST):
            return Object.assign({}, state, defaultState);
        case(SUPPORTER_EMERGENCY_CONTACT_RECEIVE):
            return Object.assign({}, state, {
                id: action.data.id,
                lastname: action.data.lastname !== null ? action.data.lastname : '',
                firstname: action.data.firstname !== null ? action.data.firstname : '',
                phone: action.data.phone !== null ? action.data.phone : '',
                type: action.data.type !== null ? action.data.type : '',
                availableTypes: action.data.availableTypes
            });
        case(SUPPORTER_EMERGENCY_CONTACT_CHANGE_VALUE):
            return Object.assign({}, state, {
                [action.name]: action.value
            });
        case(SUPPORTER_EMERGENCY_CONTACT_EDIT):
            return Object.assign({}, state, {
                edit: true
            });
        case(SUPPORTER_EMERGENCY_CONTACT_SEND_SAVE):
            return Object.assign({}, state, {
                errors: false,
                loading: true
            });
        case(SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE):
            return Object.assign({}, state, {
                edit: false,
                loading: false
            });
        case(SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE_ERROR):
            return Object.assign({}, state, {
                edit: true,
                loading: false,
                errors: action.data.errors
            });
        default:
            return state;
    }
};

export default supporterEmergencyContactReducer;